import React from 'react'
// components
import TableManagementProvider from 'containers/Search/layers/BL'
import PlansPageAPI from 'containers/Plan/Register/layers/API'
import Plans from 'components/PageComponents/Plans/Register'

const PlansContainer = () => (
  <TableManagementProvider>
    <PlansPageAPI>
      <Plans />
    </PlansPageAPI>
  </TableManagementProvider>
)

export default PlansContainer
